export default __webpack_public_path__ + "fdb8d43af2422ee8273487107007fdb8.png";